import React from "react";

const Header = () => {
    const publicUrl = window.myLocalizedData ? window.myLocalizedData.PUBLIC_URL : "";

    return (
        <header>
            <a href="/" className="site-logo">
                <img src={`${publicUrl}/logo.svg`} alt="Ascension" className="site-logo" />
            </a>
            <iframe src={`${publicUrl}/psychologytoday.html`} frameBorder="0" height={70} width={200} />
            <div className="pt-2">
                <a className="primary-link mb-2 mr-1" href="#contact">Start Your Journey!</a>
                <a className="secondary-link mb-2" href="https://natasha-sharpe.clientsecure.me" target="_blank" rel="noopener noreferrer">Client Portal</a><br />
                <i className="fa fa-phone"></i> 703-375-9846<br />
                <i className="fa fa-envelope"></i> natashasharpe@ascensioncpd.com
                <div className="text-size-xs text-color-danger pt-2">
                    Call 911 if you are having a medical or mental health emergency.
                </div>
            </div>
        </header>
    );
};

export default Header;
